import { api } from '../../api/api';

// initial state
const state = {
   type:null
};

// getters
const getters = {
};

// actions
const actions = {
   DEVICE_TYPE_SET:(context, type)=>{
      return new Promise((resolve, reject)=>{
         context.commit('DEVICE_TYPE_SET', type);
         resolve();
      });
   }
};

// mutations
const mutations = {
   DEVICE_TYPE_SET:(state,type)=>{
      state.type = type;
   }
};

export default {
   state,
   getters,
   actions,
   mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/device.js